import $ from 'jquery';
import Sloth from '../Sloth';
import './header.scss';

@Sloth.component({})
export default class Header {
    onInit() {
        if(!Sloth.isMobile()) return;

        const dom = this.dom;
        $('.Nav-container', dom).prepend($('.Header-right', dom));
    }
}



/** WEBPACK FOOTER **
 ** ./components/Header/index.js
 **/